import { Injectable } from '@angular/core';

declare let gtag:Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor() { }

  public trackEvent(
    eventName: string,    
    eventAction: string,
    eventCategory: string,
    eventLabel: string,
    eventValue: string       
  ){         
    gtag('event',
      eventName, {
      'event_category': eventCategory,
      'event_label': eventLabel,
      'event_action': eventAction,
      'value': eventValue
    });
  }  
}